import { PATH_API } from "constants/api";
import { DocumentGroupDTO } from "interfaces/dtos/documentGroupDTO";
import { ApiResponse, Pagination } from "interfaces/models/api";
import { DocumentGroup } from "interfaces/models/documentGroup";
import { axiosECS } from "services/baseAxios";

const path = PATH_API.DOCUMENT_GROUP;

interface GetDocumentGroupReq extends Pagination {
  bimFileId?: string;
  level?: string;
  signal?: AbortSignal;
  shouldCache?: boolean;
}

export const getGroupsList = async (
  params: GetDocumentGroupReq
): Promise<ApiResponse<DocumentGroup[]>> => {
  const { signal, ...rest } = params;

  // return axiosECS.get(path, {
  //   params: { ...rest, limit: rest.limit || DEFAULT_LIMIT },
  //   signal,
  // });
  // actual api temporary not in used

  return { data: [] };
};

export const createGroup = async (
  group: DocumentGroupDTO
): Promise<ApiResponse<DocumentGroup>> => {
  return axiosECS.post(path, group);
};

export const updateGroup = async (
  group: Required<Pick<DocumentGroup, "id">> & Partial<DocumentGroup>
): Promise<ApiResponse<DocumentGroup>> => {
  group.updatedAt = group.updatedAt || new Date();

  return axiosECS.patch(path, group);
};

export const deleteGroupList = async (
  ids: string[]
): Promise<ApiResponse<any[]>> => {
  return axiosECS.delete(path, { data: { ids } });
};
